import { render, staticRenderFns } from "./invoiceRecordDetail.vue?vue&type=template&id=43cff8bd&scoped=true&"
import script from "./invoiceRecordDetail.vue?vue&type=script&lang=js&"
export * from "./invoiceRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./invoiceRecordDetail.vue?vue&type=style&index=0&id=43cff8bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cff8bd",
  null
  
)

export default component.exports